/**
 * @function getCoords
 * @description Координаты элемента
 *
 * @param {HTMLElement} elem - проверяемый элемент
 */
function getCoords(elem) {

    let box = elem.getBoundingClientRect();
    return {
        top:box.top + window.scrollY,
        right:box.right + window.scrollX,
        bottom:box.bottom + window.scrollY,
        left:box.left + window.scrollX,
        height:box.height,
    };
}

/**
 * @function isOnScreen
 * @description Эта функция проверяет, находится ли заданный элемент в данный момент в видимой области окна веб-страницы.
 *
 * @param {HTMLElement} elem - проверяемый элемент
 * @param {number|null} coefficientDesktop - Число, которое регулирует точку срабатывания функции на настольных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 * @param {number|null} coefficientMobile - Число, которое регулирует точку срабатывания функции на мобильных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 *
 */
function isOnScreen(elem, coefficientDesktop = null, coefficientMobile = null) {
    // Если коэффициенты не предоставлены, используем значения по умолчанию
    if (coefficientDesktop === null && coefficientMobile === null) {
        let coefficient;
        // Используем более высокий коэффициент (0.75) для мобильных устройств
        window.innerWidth <= 768 ? coefficient = 0.75 : coefficient = 0.3;
        return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficient);
    } else {
        // Используем предоставленные коэффициенты
        if (window.innerWidth <= 768) {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientMobile);
        } else {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientDesktop);
        }
    }
}

/**
 * @function isMobile
 * @description Проверка ширины устройства (мобильный или десктоп)
 */
function isMobile() {

    return window.outerWidth <= 768;
}

/**
 * @function isExist
 * @description Проверка наличия элемента на странице
 *
 * @param {string} selector - проверяемый элемент
 */
function isExist(selector) {

    return document.querySelector( selector );
}

/**
 * @function isHome
 * @description Проверка, является ли текущая страница главной
 */
function isHome() {

    return isExist( '.home' );
}

/**
 * @function setHeaderHeight
 * @description Вычисляет высоту шапки и устанавливает CSS переменную --header-height
 * 
 * @param {string} selector - селектор элемента шапки (по умолчанию '.header')
 */
function setHeaderHeight(selector = '.header') {
    const header = document.querySelector(selector);
    
    if (header) {
        const height = header.offsetHeight;
        const computedStyle = window.getComputedStyle(header);
        const top = parseFloat(computedStyle.top) || 0;
        const totalHeight = height + top;
        
        document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
        return totalHeight;
    }
    
    return null;
}

// Яндекс Карты ленивая загрузка скрипта

function loadMapScript(target) {
    let apiKey = '09002892-0f8d-4fe0-9b1b-299125cb2f6c',
        lang = 'RU',
        script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?apikey=' + apiKey + '&lang=' + lang;
    script.type = 'text/javascript';
    script.onload = function () {
        ymaps.ready(function () {
            iniMap();
        });
    };

    document.body.appendChild(script);
}

// Яндекс Карты создание карты
function iniMap() {
    let myMap = new ymaps.Map('yandex-map', {
            center: [48.487790, 135.108793],
            zoom: 14,
            controls: []
        }),
        address = 'г. Хабаровск, ул. Хабаровская, 6/1',
        customIconImage = '/wp-content/themes/2CARROTSbox/assets/images/svg/mapIcon.svg';

    var CustomLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="custom-placemark">' +
            '<div class="custom-placemark__icon">' +
                '<img src="{{ properties.iconImageHref }}" alt="marker" />' +
            '</div>' +
        '</div>',
        {
            build: function() {
                CustomLayout.superclass.build.call(this);
                this.getParentElement().classList.add('custom-placemark-wrapper');
            }
        }
    );

    ymaps.geocode(address).then(function (res) {
        let coord = res.geoObjects.get(0).geometry.getCoordinates(),
            myPlacemark = new ymaps.Placemark(coord, {
                iconImageHref: customIconImage
            }, {
                iconLayout: CustomLayout,
                iconOffset: [-112, -73]
            });
        myMap.geoObjects.add(myPlacemark);
    });
}

// Яндекс Карты функция инициализации скрипта при прокрутке страницы
function lazyLoadMap() {
    let mapContainer = document.getElementById('yandex-map');

    if (!mapContainer) return;

    if (!('IntersectionObserver' in window)) {
        loadMapScript(mapContainer);
        return;
    }

    let observerOptions = {
        root: null,
        rootMargin: '100px',
        threshold: 0
    };

    let intersectionObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                loadMapScript(entry.target);
            }
        });
    }, observerOptions);

    intersectionObserver.observe(mapContainer);
}